import { HeaderComponent } from './components/panorama/header/header.component';
import { FooterComponent } from './components/panorama/footer/footer.component';
import { NotImplementedComponent } from './components/shared/not-implemented/not-implemented.component';
import { HeroCarouselComponent } from './components/panorama/hero-carousel/hero-carousel.component';
import { HeroComponent } from './components/panorama/hero/hero.component';
import { FeaturedComponent } from './components/panorama/featured/featured.component';
import { VisualCardComponent } from './components/shared/visual-card/visual-card.component';
import { PromoComponent } from './components/panorama/promo/promo.component';
import { SbOfferingCardComponent } from './components/storyblok/sb-offering-card/sb-offering-card.component';
import { SitemapSectionComponent } from './components/panorama/sitemap-section/sitemap-section.component';
import { OfferingHeroComponent } from './components/panorama/offering-hero/offering-hero.component';
import { OfferingRelatedComponent } from './components/panorama/offering-related/offering-related.component';
import { OfferingDetailsComponent } from './components/panorama/offering-details/offering-details.component';
import { OfferingFeaturesComponent } from './components/panorama/offering-features/offering-features.component';
import { OfferingUseCasesComponent } from './components/panorama/offering-use-cases/offering-use-cases.component';
import { OfferingCommunitiesComponent } from './components/panorama/offering-communities/offering-communities.component';
import { CenteredHeroComponent } from './components/panorama/centered-hero/centered-hero.component';
import { BreadcrumbsComponent } from './components/shared/breadcrumbs/breadcrumbs.component';
import { OfferingInstallationsComponent } from './components/panorama/offering-installations/offering-installations.component';
import { SbBreadcrumbsComponent } from './components/storyblok/sb-breadcrumbs/sb-breadcrumbs.component';
import { KnowledgeLearningResourcesComponent } from './components/panorama/knowledge-learning-resources/knowledge-learning-resources.component';
import { KnowledgeAdditionalResourcesComponent } from './components/panorama/knowledge-additional-resources/knowledge-additional-resources.component';
import { KnowledgeBestPracticesComponent } from './components/panorama/knowledge-best-practices/knowledge-best-practices.component';
import { KnowledgeFaqComponent } from './components/panorama/knowledge-faq/knowledge-faq.component';
import { KnowledgeIntegrationsComponent } from './components/panorama/knowledge-integrations/knowledge-integrations.component';
import { KnowledgeTechnicalResourcesComponent } from './components/panorama/knowledge-technical-resources/knowledge-technical-resources.component';
import { KnowledgeSuccessStoriesComponent } from './components/panorama/knowledge-success-stories/knowledge-success-stories.component';
import { KnowledgeReleaseNotesComponent } from './components/panorama/knowledge-release-notes/knowledge-release-notes.component';
import { KnowledgeUserInstructionsComponent } from './components/panorama/knowledge-user-instructions/knowledge-user-instructions.component';
import { OfferingSupportChannelsComponent } from './components/panorama/offering-support-channels/offering-support-channels.component';
import { OfferingServicesAndRequestsComponent } from './components/panorama/offering-services-and-requests/offering-services-and-requests.component';
import { OfferingAvailableVersionsComponent } from './components/panorama/offering-available-versions/offering-available-versions.component';
import { OfferingCapabilitiesComponent } from './components/panorama/offering-capabilities/offering-capabilities.component';
import { OfferingSupportHoursComponent } from './components/panorama/offering-support-hours/offering-support-hours.component';
import { OfferingEnvironmentsComponent } from './components/panorama/offering-environments/offering-environments.component';
import { MercuryFormComponent } from './components/panorama/mercury-form/mercury-form.component';
import { OfferingOnboardingStepsComponent } from './components/panorama/offering-onboarding-steps/offering-onboarding-steps.component';
import { OfferingAddonsComponent } from './components/panorama/offering-addons/offering-addons.component';
import { OfferingVendorComponent } from './components/panorama/offering-vendor/offering-vendor.component';
import { OfferingCardComponent } from './components/shared/offering-card/offering-card.component';
import { OfferingRelatedTechnologyComponent } from './components/panorama/offering-related-technology/offering-related-technology.component';
const Components = {
  // Pages
  Header: HeaderComponent,
  Footer: FooterComponent,
  // Components
  'hero-carousel': HeroCarouselComponent,
  hero: HeroComponent,
  featured: FeaturedComponent,
  'visual-card': VisualCardComponent,
  promo: PromoComponent,
  'sb-offering-card': SbOfferingCardComponent,
  'sitemap-section': SitemapSectionComponent,
  'offering-hero': OfferingHeroComponent,
  'offering-related': OfferingRelatedComponent,
  'offering-details': OfferingDetailsComponent,
  'offering-features': OfferingFeaturesComponent,
  'knowledge-learning-resources': KnowledgeLearningResourcesComponent,
  'knowledge-additional-resources': KnowledgeAdditionalResourcesComponent,
  'knowledge-integrations': KnowledgeIntegrationsComponent,
  'offering-use-cases': OfferingUseCasesComponent,
  notImplemented: NotImplementedComponent,
  'centered-hero': CenteredHeroComponent,
  breadcrumbs: BreadcrumbsComponent,
  'offering-installations': OfferingInstallationsComponent,
  'sb-breadcrumbs': SbBreadcrumbsComponent,
  'knowledge-best-practices': KnowledgeBestPracticesComponent,
  'knowledge-faq': KnowledgeFaqComponent,
  'knowledge-technical-resources': KnowledgeTechnicalResourcesComponent,
  'knowledge-success-stories': KnowledgeSuccessStoriesComponent,
  'knowledge-release-notes': KnowledgeReleaseNotesComponent,
  'knowledge-user-instructions': KnowledgeUserInstructionsComponent,
  'offering-services-and-requests': OfferingServicesAndRequestsComponent,
  'mercury-forms': MercuryFormComponent,
  'offering-available-versions': OfferingAvailableVersionsComponent,
  'offering-capabilities': OfferingCapabilitiesComponent,
  'offering-support-channels': OfferingSupportChannelsComponent,
  'offering-support-hours': OfferingSupportHoursComponent,
  'offering-environments': OfferingEnvironmentsComponent,
  'offering-communities': OfferingCommunitiesComponent,
  'offering-onboarding-steps': OfferingOnboardingStepsComponent,
  'offering-addons': OfferingAddonsComponent,
  'offering-vendor': OfferingVendorComponent,
  'offering-card': OfferingCardComponent,
  'offering-related-technology': OfferingRelatedTechnologyComponent,
};

export { Components };
